import React, { useState, useRef, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Link, useHistory } from 'react-router-dom';
import axioPath from '../../../../../../api/axioPath';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import styles from './searchTypehead.module.scss'

const SearchTypeahead = ({
  placeholder,
  minLength,
  asyncSearch,
  searchUrl,
  filterBy,
  pageType,
  toggle,
  title,
  pageName,
  transparent,
  focusOnShow,
  searchHandler,
  background,
  color,
  callBack,
  setUserNameValue
}) => {
  const typeaheadRef = useRef();
  let history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  let defaultTxt
  if (title) {
    defaultTxt = title.toString();
  }

  const [defaultState, setDefaultState] = useState('');

  useEffect(() => {
    if (focusOnShow) {
      typeaheadRef.current.focus();
    }
    if (defaultTxt === undefined) typeaheadRef.current.clear();
    if (defaultTxt != '') setDefaultState(defaultTxt)
  }, [defaultTxt]);


  const handleSearch = async (query) => {
    const token = localStorage.getItem("token")
    axioPath.get(`/user/admin/userListForPromoCode?userName=${query}`, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      if (response && response.data && response.data.status === 'SUCCESS' && response.data.payload) {
        const options = response.data.payload.map((data, index) => ({
          id: index,
          title: `${data.name} (${data.email})`,
          description: data.email
        }));
        setOptions(options);
      }
    }).catch((err) => {
    })
  }

  return (
    asyncSearch && (
      <>
        <div className={styles.typeAheadSearchInput}>
          <AsyncTypeahead
            ref={typeaheadRef}
            multiple={false}
            id={Math.random().toString()}
            labelKey="title"
            filterBy={["title", "description"]}
            isLoading={isLoading}
            minLength={minLength}
            onSearch={handleSearch}
            options={options}
            placeholder={placeholder}
            defaultInputValue={defaultState}
            onInputChange={(text) => {
              setDefaultState(text);
              handleSearch(text);
              if (text === '') setUserNameValue('', '')
            }}
            onChange={(event) => {
              if (event.length !== 0 && event[0].title) {
                handleSearch(event[0].title.toString());
                setDefaultState(event[0].title);
                setUserNameValue(event[0].title, event[0].description)
              }
            }}
            renderMenuItemChildren={(option) => <span>{option[filterBy]}</span>}
          />
        </div>
      </>
    )
  );
};

SearchTypeahead.propTypes = {
  placeholder: PropTypes.string,
  minLength: PropTypes.number,
  asyncSearch: PropTypes.bool,
  searchUrl: PropTypes.string,
  focusOnShow: PropTypes.bool,
  background: PropTypes.string,
  color: PropTypes.string,
};

SearchTypeahead.defaultProps = {
  placeholder: '',
  minLength: 1,
  asyncSearch: true,
  /**
   * @todo : SearchUrl and filterBy should be empty, this needs to be refactored after search api integration
   */
  searchUrl: 'https://api.github.com/search/users',
  filterBy: 'login',
  transparent: false,
  focusOnShow: true,
};

export default SearchTypeahead;
